import styles from '~/styles/atoms/tab/tab.module.scss'

import { addClass } from '~/common/utils/html'
import { TabType } from '~/components/atoms/tab/Tab'
import { IconTag } from '~/common/define/icon'
import Icon, { IconSize } from '~/components/atoms/icon/Icon'

export type TabItemVars = {
  text: string
  iconTag?: IconTag
}

type TabItemValueVars<T> = TabItemVars & {
  value: T
}

interface Props<T> {
  item: TabItemValueVars<T>
  onSelect(value: T): void
  selected: boolean
  type: TabType
}

const tabTypeClass = (type: TabType) => {
  switch (type) {
    case TabType.SUPPORT:
      return styles.tab__item__support
    default:
  }
  return styles.tab__item__normal
}

const TabItem = <T,>({item, onSelect, selected, type}: Props<T>) => {
  const typeClass = tabTypeClass(type)
  return (
    <li className={styles.tab__item + addClass(typeClass) + addClass(styles.selected, selected)} onClick={() => onSelect(item.value)}>
      {item.iconTag &&
        <Icon tag={item.iconTag} size={IconSize.X_SMALL}/>
      }
      {item.text}
    </li>
  )
}

export default TabItem